<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form
        ref="queryEvalProjectForm"
        :model="queryEvalProjectForm"
        label-width="80px"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="所属分类">
              <el-select
                v-model="queryEvalProjectForm.categoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-button type="primary" @click="getEvalProjectList"
              >查询</el-button
            >
            <el-button type="primary" @click="addCtiy">创建</el-button>
            <!-- <el-button type="primary">批量导出</el-button> -->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="value" label="编号"> </el-table-column>
        <el-table-column prop="name" label="成色评估信息模板名称">
        </el-table-column>
        <el-table-column prop="categoryName" label="所属分类">
        </el-table-column>
        <el-table-column prop="status" label="前端展示">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">展示</span>
            <span v-else>不展示</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              @click="editEvalProject(scope.row)"
              type="text"
              size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >展示</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不展示</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index - 1)"
              type="text"
              size="small"
              v-if="scope.$index > 0"
              >上移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index + 1)"
              type="text"
              size="small"
              v-if="scope.$index < tableData.length - 1"
              >下移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, 0, true)"
              type="text"
              size="small"
              >置顶</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, -1, true)"
              type="text"
              size="small"
              >置底</el-button
            >
            <el-button @click="deleteEvaluationTemplate(scope.row.id)" type="text" size="small" style="color: red;">删除</el-button> 
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="
        dlgType === 'change' ? '编辑成色信息评估模板' : '新建成色信息评估模板'
      "
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editEvalProjectForm"
            :model="editEvalProjectForm"
            :rules="editorFormRules"
            label-width="140px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editEvalProjectForm.value"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属分类" prop="categoryId">
              <el-select
                v-model="editEvalProjectForm.categoryId"
                placeholder="请选择"
                @change="getTemplateValue(false)"
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="模板名称" prop="name">
              <el-input clearable v-model="editEvalProjectForm.name"></el-input>
            </el-form-item>
            <el-form-item label="评估内容及选项值"> </el-form-item>
            <div v-if="isRefresh">
              <template-value-option
                v-for="(item, index) in templateValueArray"
                :key="index"
                :index="index"
                :template-array="item"
                @changeTemplateValueArray="changeTemplateValueArray"
              ></template-value-option>
            </div>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TemplateValueOption from "../../components/templateValueOption.vue";
export default {
  components: { TemplateValueOption },
  props: {},
  data() {
    return {
      // 查询数据
      queryEvalProjectForm: {
        categoryId: null,
      },
      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      checkList: [],

      // 新建编辑对话框数据
      isDlg: false,
      editEvalProjectForm: {
        id: null,
        value: null,
        name: null,
        templateKey: null,
        type: 2,
        extParam: null,
        categoryId:null
      },

      editorFormRules: {
        name: [
          { required: true, message: "请输入模板名称", trigger: "change" },
        ],
        categoryId: [
          { required: true, message: "请输入所属分类", trigger: "change" },
        ],
        // checkList: [
        //   { required: true, message: "请选择评估内容", trigger: "change" },
        // ],
      },

      dlgType: "change",

      loading: false,

      isRefresh: false,
      templateValueArray: [],
      initTemplateValueArray: [],
      categoryOptions: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    deleteEvaluationTemplate(id){
      let self = this
      self.$confirm('是否删除').then(() => {
          self.$api.deleteEvaluationTemplate({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getEvalProjectList()
          }
      })
      })
    
    },
    getCategory() {
      let self = this;
      self.$api
        .getClass({
          typeKey: "category",
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          self.categoryOptions = res.data.records || [];
        });
    },
    changeTemplateValueArray(index, templateArray) {
      this.templateValueArray[index] = templateArray;
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getEvalProjectList();
    },

    // 获取表格数据
    getEvalProjectList() {
      let self = this;
      self.$api
        .templateListSearch({
          type: 2,
          page: self.currentPage,
          size: self.pageSize,
          categoryId: self.queryEvalProjectForm.categoryId,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addCtiy() {
      let self = this;
      this.dlgType = "new";
      this.editEvalProjectForm = this.$options.data().editEvalProjectForm;
      this.$nextTick(()=>{
          this.$refs['editEvalProjectForm'].clearValidate()
      })
      self.templateValueArray = [];
      // self.isRefresh = false;
      // this.$nextTick(() => {
      //   self.isRefresh = true;
      // });
      this.isDlg = true;
    },

    // 修改
    editEvalProject(row) {
      let self = this;
      self.dlgType = "change";
      self.editEvalProjectForm = JSON.parse(JSON.stringify(row));
      self.getTemplateValue(true);
      self.isDlg = true;
    },

    //修改时初始化选中值
    initSelectOptionData() {
      let self = this;
      let selectOption = JSON.parse(self.editEvalProjectForm.extParam);
      selectOption.forEach((e) => {
        self.templateValueArray.forEach((e1) => {
          if (e.id === e1.id) {
            e1.selected = e.selected;
            e.children.forEach((e2) => {
              e1.children.forEach((e3) => {
                if (e2.id === e3.id) {
                  e3.selected = e2.selected;
                }
              });
            });
          }
        });
      });
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editEvalProjectForm"].validate((valid) => {
        if (valid) {
          let params = self.editEvalProjectForm;
          params.extParam = self.templateValueArray!=null?JSON.stringify(self.templateValueArray):null;
          params.templateKey = "evaluate_condition,evaluate_value";
          params.type = 2;
          self.$api.updateEvaluationTemplate(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getEvalProjectList();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      self.$api.updateEvaluationTemplate(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getEvalProjectList();
        }
      });
    },
    upDownMove(id, toIndex, type) {
      let self = this;
      self.$api
        .evaluationTemplateSwap({
          currentId: id,
          swapId: type ? toIndex : self.tableData[toIndex].id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "移动成功",
              type: "success",
            });
            self.getEvalProjectList();
          }
        });
    },
    getTemplateValue(isEdit) {
      let self = this;
      self.$api
        .getTemplateValue({
          categoryId: self.editEvalProjectForm.categoryId,
          typeKey: "evaluate_condition,evaluate_value,category",
        })
        .then((res) => {
          self.templateValueArray = res.data;
          if (isEdit) {
            self.initSelectOptionData();
          }
          self.isRefresh = false;
          this.$nextTick(() => {
            self.isRefresh = true;
          });
        });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getEvalProjectList();
    self.getCategory();
  },
};
</script>
<style lang="less" scoped></style>
